import {
  gql,
  NetworkStatus,
  useQuery
} from "@apollo/client";
import { Link } from "react-router-dom";

import { client } from "../../services/client";
import { RadialBar } from "../ProgressBar";

import "./index.css"

export const FIND_MOVIE_BY_ID = gql`
  query FindMovieById ($id: String) {
    movie(id: $id) {
      imdbID
      Title
      Year
      Rated
      Released
      Runtime
      Genre
      Director
      Writer
      Actors
      Plot
      Language
      Country
      Awards
      Poster
      Metascore
      imdbRating
      imdbVotes
      Type
      DVD
      BoxOffice
      Production
      Website
    }
  }
`;

export function ProfileComponent({ id }: { id: string }) {
  const { data, networkStatus, error } = useQuery(
    FIND_MOVIE_BY_ID,
    {
      client,
      notifyOnNetworkStatusChange: true,
      variables: {
        id
      }
    }
  );

  if (networkStatus === NetworkStatus.loading) {
    return <div>Loading ...</div>;
  }

  if (error) {
    return <div>{error.message}</div>;
  }

  return (
    <>
      <div className="wrapper">
        <Link to="/">{"<"} Retour a la recherche</Link>
        <div className="content_wrapper">
          <img src={data.movie.Poster} alt={`Poster ${data.movie.Title}`} />
          <section className="details">
            <div className="title">
              <h2>
                <a href={`https://www.imdb.com/title/${data.movie.imdbID}/?ref_=tt_pg`} target="_blank" rel="noreferrer">{data.movie.Title}</a>
                <span className="release_date">({data.movie.Year})</span>
              </h2>
              <div className="facts">
                <span className="certification">{data.movie.Rated}</span>
                <span className="release">{data.movie.Released}</span>
                <span className="runtime">{data.movie.Genre}</span>
                <span className="genres">{data.movie.Runtime}</span>
              </div>
            </div>
            <ul className="ratings">
              <li className="metascore">
                <RadialBar percentage={data.movie.Metascore} size={60} />
              </li>
              <li className="text">
                Note<br/>des<br/>utilisateurs
              </li>
              <li className="imdb_ratings">
                <a href={`https://www.imdb.com/title/${data.movie.imdbID}/ratings/?ref_=tt_pg`} target="_blank" rel="noreferrer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="64" height="32" viewBox="0 0 64 32" version="1.1"><g fill="#F5C518"><rect x="0" y="0" width="100%" height="100%" rx="4"></rect></g><g transform="translate(8.000000, 7.000000)" fill="#000000" fillRule="nonzero"><polygon points="0 18 5 18 5 0 0 0"></polygon><path d="M15.6725178,0 L14.5534833,8.40846934 L13.8582008,3.83502426 C13.65661,2.37009263 13.4632474,1.09175121 13.278113,0 L7,0 L7,18 L11.2416347,18 L11.2580911,6.11380679 L13.0436094,18 L16.0633571,18 L17.7583653,5.8517865 L17.7707076,18 L22,18 L22,0 L15.6725178,0 Z"></path><path d="M24,18 L24,0 L31.8045586,0 C33.5693522,0 35,1.41994415 35,3.17660424 L35,14.8233958 C35,16.5777858 33.5716617,18 31.8045586,18 L24,18 Z M29.8322479,3.2395236 C29.6339219,3.13233348 29.2545158,3.08072342 28.7026524,3.08072342 L28.7026524,14.8914865 C29.4312846,14.8914865 29.8796736,14.7604764 30.0478195,14.4865461 C30.2159654,14.2165858 30.3021941,13.486105 30.3021941,12.2871637 L30.3021941,5.3078959 C30.3021941,4.49404499 30.272014,3.97397442 30.2159654,3.74371416 C30.1599168,3.5134539 30.0348852,3.34671372 29.8322479,3.2395236 Z"></path><path d="M44.4299079,4.50685823 L44.749518,4.50685823 C46.5447098,4.50685823 48,5.91267586 48,7.64486762 L48,14.8619906 C48,16.5950653 46.5451816,18 44.749518,18 L44.4299079,18 C43.3314617,18 42.3602746,17.4736618 41.7718697,16.6682739 L41.4838962,17.7687785 L37,17.7687785 L37,0 L41.7843263,0 L41.7843263,5.78053556 C42.4024982,5.01015739 43.3551514,4.50685823 44.4299079,4.50685823 Z M43.4055679,13.2842155 L43.4055679,9.01907814 C43.4055679,8.31433946 43.3603268,7.85185468 43.2660746,7.63896485 C43.1718224,7.42607505 42.7955881,7.2893916 42.5316822,7.2893916 C42.267776,7.2893916 41.8607934,7.40047379 41.7816216,7.58767002 L41.7816216,9.01907814 L41.7816216,13.4207851 L41.7816216,14.8074788 C41.8721037,15.0130276 42.2602358,15.1274059 42.5316822,15.1274059 C42.8031285,15.1274059 43.1982131,15.0166981 43.281155,14.8074788 C43.3640968,14.5982595 43.4055679,14.0880581 43.4055679,13.2842155 Z"></path></g></svg>
                  <div className="numbers">
                    <span>{data.movie.imdbRating}/10</span>
                    <span>{data.movie.imdbVotes}</span>
                  </div>
                </a>
              </li>
            </ul>
            <h3>Synopsis</h3>
            <p className="plot">{data.movie.Plot}</p>
            <div className="grid">
              <div><h4>Director</h4>{data.movie.Director}</div>
              <div><h4>Writer</h4>{data.movie.Writer}</div>
              <div><h4>Actors</h4>{data.movie.Actors}</div>
            </div>
            <div className="wide">
              <div><h4>Language</h4>{data.movie.Language}</div>
            </div>
            <div className="grid">
              <div><h4>DVD</h4>{data.movie.DVD}</div>
              <div><h4>BoxOffice</h4>{data.movie.BoxOffice}</div>
              <div><h4>Production</h4>{data.movie.Production}</div>
            </div>
            <div className="wide">
              <div><h4>Country</h4>{data.movie.Country}</div>
              <div><h4>Awards</h4>{data.movie.Awards}</div>
              <div><h4>Website</h4>{data.movie.Website}</div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
